import { useApi } from "../app/ApiProvider";
import { Badge } from "../ui/primitives";

/** Mock / Real と Contract検証状態を常時表示し、接続済みと錯覚させない。 */
export function BackendModeBadge({ compact = false }: { compact?: boolean }) {
	const { mode, contract, pin } = useApi();
	if (mode === "mock") {
		return (
			<span title={`Contract pin ${pin.contractVersion}`}>
				<Badge tone="warning">{compact ? "Mock" : "Mock データ"}</Badge>
			</span>
		);
	}
	if (contract.status === "ok") {
		return (
			<span title={`contractHash ${contract.contractHash.slice(0, 12)}…`}>
				<Badge tone="success">
					{compact ? "接続中" : `Zerovia 接続中 v${contract.contractVersion}`}
				</Badge>
			</span>
		);
	}
	if (contract.status === "checking") return <Badge tone="neutral">接続確認中…</Badge>;
	if (contract.status === "error") {
		return (
			<span title={contract.message}>
				<Badge tone="danger">
					{contract.kind === "MISMATCH" ? "Contract不一致" : "Backend未接続"}
				</Badge>
			</span>
		);
	}
	return <Badge tone="neutral">—</Badge>;
}
